import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

function Editorial({title}) {

    useEffect(() => {
            document.title = title;
        }, [title]);

    const [editors, setEditors] = useState([]);

    const [editorInChief, setEditorInChief] = useState([]);

    useEffect(() => {
        fetch("https://annalsofnursing.org/aon_backend/api/api.php?action=getAllEditors")
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    const chief = data.editors.filter(editor => editor.id === 6);
                    const others = data.editors.filter(editor => editor.id !== 6);

                    if (chief.length > 0) {
                        setEditorInChief(chief);
                        setEditors(others);
                    } else {
                        setEditors(data.editors);
                    }
                } else {
                    console.error("API Error:", data.error);
                }
            })
            .catch(error => console.error("Error fetching editors:", error));
    }, []);

    return (
      <>
        <div className='instructions_section'>
            <div className="instructions_wrapper">
                <h2 className='instructions_title'>
                    Editorial Board
                </h2>

                <hr class="instructions_hr"/>

                <div className='editorail_eic_wrapper'>
                    {editorInChief.map((editor) => (
                        <div key={editor.id} className='editorail_block'>
                            <div className='editorial_circle_wrapper'>
                                <div className='editorial_image_block'>
                                    <img
                                        src={editor.image}
                                        alt={editor.title}
                                        className={"index" + editor.id}
                                    />
                                </div>
                                <div className={"editorial_circle circle" + editor.id}> 

                                </div>
                            </div>
                            

                            <p className='editorial_title'>
                               {parse(editor.title)}
                            </p>

                            <p className='editorial_education'>
                                {parse(editor.education)}
                            </p>

                            <p className='editorial_email'>
                                {editor.email}
                            </p>

                        </div>
                    ))}
                </div>

                <div className='editorail_wrapper'>

                    {editors.slice().reverse().map((editor) => (
                        <div key={editor.id} className='editorail_block'>
                            <div className='editorial_circle_wrapper'>
                                <div className='editorial_image_block'>
                                    <img
                                        src={editor.image}
                                        alt={editor.title}
                                        className={"index" + editor.id}
                                    />
                                </div>
                                <div className={"editorial_circle circle" + editor.id}> 

                                </div>
                            </div>
                            

                            <p className='editorial_title'>
                               {parse(editor.title)}
                            </p>

                            <p className='editorial_education'>
                                {parse(editor.education)}
                            </p>

                            <p className='editorial_email'>
                                {editor.email}
                            </p>

                        </div>
                    ))}

                </div>
            </div>
            <br/><br/>
        </div>
      </>
    );
}

export default Editorial;